export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "423732e.worker.js");
}
